import React, { Fragment, useState } from 'react';
import cn from 'classnames';
import { AsyncSelect } from "../../../common/components/Select/Select";
import {
  addAdminCalendarDesigner,
  adminSearchDesigners,
  removeAdminCalendarDesigner,
} from "../api/AdminCalendarApi";

// search results and calendar designers carry the same avatar/initials shape, but a designer
// added during this session comes from the search, so fall back to initials from the name
const DesignerAvatar = ({ designer }) => {
  const initials =
    designer.initials ||
    (designer.full_name || '').split(' ').filter(Boolean).map(word => word[0]).join('').slice(0, 3);
  return (
    <div className="designer-avatar">
      {designer.avatar ? (
        <img src={designer.avatar.url} alt={designer.full_name} />
      ) : (
        <div className="designer-initials">{initials}</div>
      )}
    </div>
  );
};

const AddDesignerPopup = ({ calendar, designers: initialDesigners, onCloseModal }) => {
  const [designers, setDesigners] = useState(initialDesigners);
  // ticked == on the calendar; changes are only sent to the server when Ok is pressed
  const [checkedIds, setCheckedIds] = useState(initialDesigners.map(designer => designer.id));
  const [saving, setSaving] = useState(false);
  const [initialIds] = useState(initialDesigners.map(designer => designer.id));

  const shortDomain = email => email.replace(/(@)[^)]*/g, "$1mbr");

  const prepareUserValues = designersArray =>
    designersArray.reduce((acct, d) => {
      acct.push({ ...d, value: d.id, label: `${d.full_name} <${shortDomain(d.email)}>` });
      return acct;
    }, []);

  const handleLoadOptions = (search, callback) => {
    adminSearchDesigners(
      calendar,
      search,
      data => {
        // setDesigners(data.designers);
        callback(prepareUserValues(data.designers));
      },
      error => {
        console.log(error);
      },
    );
    return null;
  };

  // picking a designer from the search stages them straight away: ticked, at the top of the list
  const onDesignerOptionChange = (option) => {
    if (!option) return;
    if (!designers.some(designer => designer.id === option.id)) {
      setDesigners([option, ...designers]);
    }
    if (!checkedIds.includes(option.id)) {
      setCheckedIds([...checkedIds, option.id]);
    }
  };

  const toggleDesigner = designerId => {
    setCheckedIds(
      checkedIds.includes(designerId)
        ? checkedIds.filter(id => id !== designerId)
        : [...checkedIds, designerId],
    );
  };

  const handleOk = () => {
    const toAdd = checkedIds.filter(id => !initialIds.includes(id));
    const toRemove = initialIds.filter(id => !checkedIds.includes(id));
    if (!toAdd.length && !toRemove.length) {
      onCloseModal();
      return;
    }
    setSaving(true);
    Promise.all([
      ...toAdd.map(id => addAdminCalendarDesigner(calendar, id)),
      ...toRemove.map(id => removeAdminCalendarDesigner(calendar, id)),
    ])
      .then(onCloseModal)
      .catch(error => {
        console.log(error);
        setSaving(false);
      });
  };

  const styles = {}; // Add custom styles if necessary

  return (
    <Fragment>
      <div className="popupBackShadow" onClick={onCloseModal} />
      <div className="simplePopup addRemoveDeignerPopup">
        <div className="moodboard-modal_close" onClick={onCloseModal} />
        <h2>Add/Remove Designers</h2>

        <div className="popupInputsOneLine">
          <AsyncSelect
            loadOptions={handleLoadOptions}
            value={null}
            onChange={onDesignerOptionChange}
            formatOptionLabel={option => (
              <div className="designer-option">
                <DesignerAvatar designer={option} />
                <span>{option.label}</span>
              </div>
            )}
            styles={styles}
            placeholder="Search for a designer"
            className='popupInput'
          />
        </div>

        <div className="designer-list">
          {designers.map((designer) => (
            <label
              key={designer.id}
              className={cn('designer-item', {
                '-unchecked': !checkedIds.includes(designer.id),
                '-new': !initialIds.includes(designer.id),
              })}
            >
              <input
                type="checkbox"
                checked={checkedIds.includes(designer.id)}
                onChange={() => toggleDesigner(designer.id)}
              />
              <DesignerAvatar designer={designer} />
              <span>{`${designer.full_name} (${shortDomain(designer.email)})`}</span>
            </label>
          ))}
        </div>

        <div className={'popupActions'}>
          <button onClick={onCloseModal} className="btn -empty -y2023">
            Cancel
          </button>
          <button onClick={handleOk} className="btn -empty -y2023" disabled={saving}>
            Ok
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default AddDesignerPopup;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/AddDesignerPopup.js